import type { Role } from "../../../../state/role";
import type { IconName } from "../../../../components/icon/Icon";
import type { IconTileBgColor, IconTileColor } from "../../../../components/icon/IconTile";
import { isAccountAdministrator } from "../../../../utils/roleUtil";

export type RoleIconAppearanceType = { bgColor: IconTileBgColor; icon: IconName; color: IconTileColor };

export const RoleIconAppearance = (role: Role): RoleIconAppearanceType =>
  isAccountAdministrator(role)
    ? { icon: "shield", color: "icon-theme-purple", bgColor: "bg-accent-subtle-purple" }
    : { icon: "user", color: "icon-brand", bgColor: "bg-accent-brand-subtle" };
